'use strict';

var QaDetailController = /*@ngInject*/ function (
  $state,
  $stateParams,
  $q,
  JobService,
  ColorReferenceService,
  SearchService,
  Session,
  NotificationService,
  NoteService,
  ReactNavigationService,
  COLOR_REFERENCE,
  META_STATUS
) {
  var _self = this;
  _self.colorReferences = [];
  _self.showProblemModal = false;
  _self.showResolveProblemModal = false;
  _self.error = {
    active: false,
    data: {
      type: 'error',
      heading: {
        title: 'Job Not Found',
        copy: 'This job does not exist, or is no longer in the pipeline.',
      },
      cta: {
        primary: 'Go To Search',
      },
    },
    onSubmit: function () {
      ReactNavigationService.goToSearch();
    },
  };

  _self.handleReviewCompletion = function ($event) {
    var searchParams = {
      term: '*',
      page: 0,
      size: 50,
      sort: 'priority|desc,tasks.startedOn|asc',
      filters:
        'status=' +
        META_STATUS.qa +
        ',processedForSeconds=60' +
        ',assignees=' +
        Session.get('userName'),
    };

    _self.working = true;

    SearchService.search(searchParams)
      .then(function (response) {
        var jobs = response.data.results.filter(function (job) {
          return job.id !== $event.job.id;
        });

        if (jobs.length) {
          $state.go(
            'qa',
            {
              id: jobs[0].id,
              assetJobId: undefined,
              source: $stateParams.source,
              tab: $stateParams.tab,
            },
            {
              location: 'replace',
            }
          );
        } else {
          ReactNavigationService.goToQAQueue($stateParams.tab);
        }
      })
      .catch(function () {
        ReactNavigationService.goToQAQueue($stateParams.tab);
      })
      .finally(function () {
        NotificationService.push($event.notification, $event.job);
        _self.working = false;
      });
  };

  _self.onHeaderChange = function ($event) {
    if ($event && $event.type === 'problemsolve') {
      _self.initiateProblemSolve();
    }
  };

  _self.initiateProblemSolve = function () {
    _self.showProblemModal = true;
  };

  _self.onMoveToProblemSolve = function () {
    ReactNavigationService.goToQAQueue($stateParams.tab);
  };

  _self.closeQADetail = function () {
    if ($stateParams.source === 'search') {
      ReactNavigationService.goToSearch();
      return;
    }

    ReactNavigationService.goToQAQueue($stateParams.tab);
  };

  _self.updateNotes = function ($event) {
    if ($event && $event.type === 'resolveproblem') {
      _self.showResolveProblemModal = true;
      return;
    }

    if ($event && $event.job) {
      _self.data = $event.job;
    }
  };

  _self.handleResolve = function ($event) {
    _self.showResolveProblemModal = false;

    var promise;
    if ($event.note) {
      _self.working = true;
      promise = NoteService.addNote('problem', $event.note, $event.job.id);
    } else {
      promise = $q.when({ data: $event.job });
    }

    promise
      .then(function (response) {
        _self.data = response.data;
      })
      .finally(function () {
        _self.working = false;
      });
  };

  _self.init = function () {
    _self.working = true;

    JobService.getJobDetail($stateParams.id, {
      RequestUpdatedProductInfo: true,
    })
      .then(function (result) {
        _self.data = result.data;

        const hasFCO = result.data.product.assets.some((asset) =>
          asset.viewCode.toLowerCase().startsWith('fco')
        );
        const useColorReferences =
          result.data.merchType === 'Product' &&
          result.data.jobType !== 'Variation' &&
          !hasFCO;
        const colorReferencesPromise = useColorReferences
          ? ColorReferenceService.getColorReferencesByJobId(result.data.id)
          : undefined;

        _self.hasReviewComments = false;
        if (_self.data.notes && _self.data.notes.length > 0) {
          _self.hasReviewComments = _self.data.notes.filter(function (a) {
            return a.noteType === 'Product Review';
          });
        }

        return colorReferencesPromise;
      })
      .then(function (colorReferencesResponse) {
        if (!colorReferencesResponse) {
          _self.colorReferences = undefined;
          return;
        }

        const colorReferences = colorReferencesResponse.data || [];
        _self.colorReferences = colorReferences.sort((a, b) => {
          if (
            a.type === COLOR_REFERENCE.TYPE.CALCULATED &&
            b.type !== COLOR_REFERENCE.TYPE.CALCULATED
          ) {
            return -1;
          }
          if (
            b.type === COLOR_REFERENCE.TYPE.CALCULATED &&
            a.type !== COLOR_REFERENCE.TYPE.CALCULATED
          ) {
            return 1;
          }

          if (
            a.type === COLOR_REFERENCE.TYPE.MANUAL &&
            a.override &&
            !(b.type === COLOR_REFERENCE.TYPE.MANUAL && b.override)
          ) {
            return -1;
          }
          if (
            b.type === COLOR_REFERENCE.TYPE.MANUAL &&
            b.override &&
            !(a.type === COLOR_REFERENCE.TYPE.MANUAL && a.override)
          ) {
            return 1;
          }

          return 0;
        });
      })
      .catch(function () {
        _self.error.active = true;
      })
      .finally(function () {
        _self.working = false;
      });
  };

  _self.init();
};

module.exports = QaDetailController;
